export const selectVendorsList = (store) =>
  store.vendorsState.sort((a, b) => a < b );



// WEBPACK FOOTER //
// ./src/store/selectors/vendors.js